import { useQuery } from '@tanstack/react-query'
import { searchApi } from '@/api/search'
import { useDebounce } from '@/shared/hooks/useDebouncedValue'

export function useSearch(query: string, projectId?: string) {
  const debouncedQuery = useDebounce(query, 300)

  return useQuery({
    queryKey: ['search', debouncedQuery, projectId],
    queryFn: async () => {
      try {
        return await searchApi.search(debouncedQuery, projectId)
      } catch {
        return { results: [] }
      }
    },
    enabled: debouncedQuery.length >= 2,
    staleTime: 60_000, // 1 minute cache
  })
}
